import "../Button/Button.css";
import "../../style/style.css";

// 1. useNavigate 훅 임포트를 제거합니다.
import { useNavigate } from "react-router-dom";

export function ChooseButton() {
  const navigate = useNavigate();
  const handleStart = () => {
    navigate("/solo");
  };

  return (
    <div className="choose-btn" onClick={handleStart}>
      <p className="text3">선택하기</p>
    </div>
  );
}
export function StartButton({ onClick }) {
    // 2. [제거] 기존의 하드코딩된 handleStart 함수를 제거합니다.

    return (
      // [수정] onClick 핸들러를 외부에서 받은 prop으로 연결
      <div className="start-btn" onClick={onClick}>
        <p className="text3">시작</p>
      </div>
    );
}